import net from "App/net";

var FoulingDiagnosticsClient = function () { };

FoulingDiagnosticsClient.prototype.getDiagnostics = function (vesselId) {
  return net.get(`/Fouling/Diagnostics`, { vesselId: vesselId });
};

export default new FoulingDiagnosticsClient();
